import { render } from "./ProductItems.vue?vue&type=template&id=132ebee4"
import script from "./ProductItems.vue?vue&type=script&lang=js"
export * from "./ProductItems.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__